import React from 'react';
import { Navbar } from '../components/layouts/Navbar';
import ProducaoCard from '../components/home/ProducaoCard';
import AgendaCard from '../components/home/AgendaCard';
import SinistroCard from '../components/home/SinistroCard';
import RenovacaoCard from '../components/home/RenovacaoCard';
import CotacaoCard from '../components/home/CotacaoCard';
import PropostaCard from '../components/home/PropostaCard';

const Home: React.FC = () => {
  return (
    <>
      <Navbar />
      <div className="container mx-auto px-3 py-3">
        <h1 className="text-base font-semibold mb-3 text-gray-700">Home</h1>
        
        {/* Layout em 3 colunas */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
          {/* Coluna 1 */}
          <div className="space-y-3">
            <ProducaoCard />
            <AgendaCard />
          </div>
          
          {/* Coluna 2 */}
          <div className="space-y-3">
            <PropostaCard />
            <CotacaoCard />
          </div>
          
          {/* Coluna 3 */}
          <div className="space-y-3">
            <RenovacaoCard />
            <SinistroCard />
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
